import store from '../reducers'
import events from './events'
import Actions from './Actions'
import { 
    PatientActions,
    ConfigActions,
    PageActions, 
    AppointmentActions, 
    CardActions,
    ClassificationActions,
    BreedActions,
    GenderActions,
    FilterActions
} from 'actions'

export default class SessionActions extends Actions{
    static get target(){
        return 'session'
    }

    static set(value) {
        events.trigger('willSetSession', value)
        super.set(value)
        CardActions.fromArray(value.cards)
        events.trigger('didSetSession', value)
    }
    
    static setAccount(account) {
        events.trigger('willSetAccount', account)
        this.set({
            ...store.getState().session,
            account
        })
        events.trigger('didSetAccount', account)
    }

    static setAccess(value){
        this.set({
            ...store.getState().session,
            organizations: [...store.getState().session.organizations, value]
        })
    }
    
    static logout() {
        events.trigger('willLogout')
        this.set({})
        PatientActions.set({})
        BreedActions.set({})
        ClassificationActions.set({})
        GenderActions.set({})
        AppointmentActions.set({})
        FilterActions.set({})
        PageActions.reset()

        events.trigger('didLogout')
    }

    static clear(){
        this.set({})
    }

    static setConfig(data) {
        ConfigActions.set(data)
    }

    static setAuthenticationMode(authenticationMode) {
        return this.merge({
            authenticationMode
        })
    }
}


// WEBPACK FOOTER //
// ./actions/SessionActions.js